'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _kepler = require('kepler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DownloadPayout = function (_React$Component) {
	_inherits(DownloadPayout, _React$Component);

	function DownloadPayout(props) {
		_classCallCheck(this, DownloadPayout);

		var _this = _possibleConstructorReturn(this, (DownloadPayout.__proto__ || Object.getPrototypeOf(DownloadPayout)).call(this, props));

		_this.downloadPayoutData = _this.downloadPayoutData.bind(_this);
		return _this;
	}

	_createClass(DownloadPayout, [{
		key: 'getFromDate',
		value: function getFromDate() {
			var lastOneMonth = (0, _moment2.default)().subtract(31, 'days');
			return (0, _moment2.default)(lastOneMonth).format('YYYY/MM/DD').replace(/\//gi, '');
		}
	}, {
		key: 'getToDate',
		value: function getToDate() {
			var todayDate = (0, _moment2.default)();
			return (0, _moment2.default)(todayDate).format('YYYY/MM/DD').replace(/\//gi, '');
		}
	}, {
		key: 'validateFromDate',
		value: function validateFromDate() {
			var fromDate = this.props.fromDate;
			var validFlag = true;
			if (fromDate === null || fromDate === '' || fromDate === 'undefined') {
				(0, _jquery2.default)('.fromDateReqErr').removeClass('hide');
				validFlag = false;
			} else {
				validFlag = fromDate;
			}
			return validFlag;
		}
	}, {
		key: 'validateToDate',
		value: function validateToDate() {
			var toDate = this.props.toDate;
			var date = '';
			if (toDate === null || toDate === '' || toDate === 'undefined') {
				date = (0, _moment2.default)();
			} else {
				date = toDate;
			}
			return date;
		}
	}, {
		key: 'validateDonorName',
		value: function validateDonorName() {
			var donorName = this.props.donorName;
			var validFlag = true;
			if (donorName.length > 0 && donorName.length < 3) {
				(0, _jquery2.default)('.errorMsg2').removeClass('hide');
				validFlag = false;
			}
			return validFlag;
		}
	}, {
		key: 'validateDateDifference',
		value: function validateDateDifference(date1, date2) {
			var dateB = (0, _moment2.default)(date1);
			var dateC = (0, _moment2.default)(date2);
			var validFlag = true;
			var difference = dateC.diff(dateB, 'days');
			if (difference > 90 || difference < 0) {
				(0, _jquery2.default)('.errorMsg3').removeClass('hide');
				validFlag = false;
			}
			return validFlag;
		}
	}, {
		key: 'downloadPayoutData',
		value: function downloadPayoutData() {
			var self = this;
			self.props.clearErrorMsgs();
			if (self.props.btnType === 'csv') {
				self.downloadCSVFile();
			} else {
				self.sendParams();
			}
		}
	}, {
		key: 'sendParams',
		value: function sendParams(csv, params) {
			var reqToSend = {
				_csrf: this.props.csrf,
				pageNo: this.props.pageNo || 1,
				donorName: this.props.donorName || '',
				fromDate: csv ? params.fromDate : this.getFromDate(),
				toDate: csv ? params.toDate : this.getToDate(),
				charityType: this.props.charityType,
				charityName: this.props.charityName,
				partner: this.props.inputPartnerSelect,
				program: this.props.inputProgramSelect
			};
			this.props.downloadCSV(reqToSend);
		}
	}, {
		key: 'downloadCSVFile',
		value: function downloadCSVFile() {

			var donorName = void 0,
			    fromDate = void 0,
			    toDate = void 0,
			    dateDifference = void 0;

			donorName = this.validateDonorName();

			if (donorName) {
				fromDate = this.validateFromDate();
			} else {
				return;
			}

			if (fromDate) {
				toDate = this.validateToDate();
			} else {
				return;
			}

			if (toDate) {
				dateDifference = this.validateDateDifference(fromDate, toDate);
			} else {
				return;
			}

			if (!dateDifference) {
				return;
			}

			var params = {
				fromDate: (0, _moment2.default)(fromDate).format('YYYY/MM/DD').replace(/\//gi, ''),
				toDate: (0, _moment2.default)(toDate).format('YYYY/MM/DD').replace(/\//gi, '')
			};

			this.sendParams(true, params);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					_kepler.Button,
					{ type: this.props.type,
						className: 'filterButton',
						onClick: function onClick() {
							return _this2.downloadPayoutData();
						}
					},
					this.props.text
				)
			);
		}
	}]);

	return DownloadPayout;
}(_react2.default.Component);

DownloadPayout.propTypes = {
	activityData: _react.PropTypes.object,
	csrf: _react.PropTypes.string,
	pageNo: _react.PropTypes.number,
	donorName: _react.PropTypes.string,
	fromDate: _react.PropTypes.string,
	toDate: _react.PropTypes.string,
	charityType: _react.PropTypes.string,
	charityName: _react.PropTypes.string,
	partner: _react.PropTypes.string,
	program: _react.PropTypes.string,
	downloadCSV: _react.PropTypes.func,
	clearErrorMsgs: _react.PropTypes.func,
	text: _react.PropTypes.string,
	type: _react.PropTypes.string,
	btnType: _react.PropTypes.string,
	inputPartnerSelect: _react.PropTypes.string,
	inputProgramSelect: _react.PropTypes.string
};

exports.default = DownloadPayout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/ppgf-components/dist/components/downloadPayout.js
// module id = 502
// module chunks = 0